/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProjectBasicSettingAttributeInfo = {
    key?: ProjectBasicSettingAttributeInfo.key;
    value?: string;
};

export namespace ProjectBasicSettingAttributeInfo {

    export enum key {
        CONTRACT_ADDRESS = 'CONTRACT_ADDRESS',
        DENOM = 'DENOM',
    }


}

